<template>
  <v-card-text class="py-0">
    <v-timeline align-top dense>
      <v-timeline-item
        :color="index % 2 == 0 ? 'orange' : 'grey darken-2'"
        small
        v-for="(val, index) in data.remark"
        :key="index"
      >
        <v-row class="pt-1">
          <v-col cols="12" sm="3">
            <strong>{{ val.datetime }}</strong>
          </v-col>
          <v-col>
            <strong>{{ val.username }}</strong>
            <div class="caption">
              {{ val.role }}
            </div>
            <div>{{ val.remark }}</div>
          </v-col>
        </v-row>
      </v-timeline-item>
    </v-timeline>
  </v-card-text>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
};
</script>
